"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HtmlSanitizer = _interopRequireDefault(require("../sanitizers/HtmlSanitizer"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  white-space: ", ";\n\n  table {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  pre {\n    white-space: pre-wrap;\n  }\n\n  [data-email-reply] {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledText = (0, _styledComponents.default)(function (props) {
  var Tag = props.tagName,
      __isPlainText = props.isPlainText,
      rest = (0, _objectWithoutProperties2.default)(props, ["tagName", "isPlainText"]);
  return _react.default.createElement(Tag, rest);
}).withConfig({
  displayName: "SanitizedText__StyledText",
  componentId: "sc-1kx61ul-0"
})(_templateObject(), function (_ref) {
  var isPlainText = _ref.isPlainText;
  return isPlainText && 'pre-wrap';
});
var propTypes = {
  body: _propTypes.default.string.isRequired,
  formattingOptions: _propTypes.default.shape({
    isPlainText: _propTypes.default.bool,
    shouldAutolinkTwitter: _propTypes.default.bool,
    shouldIncludeReplies: _propTypes.default.bool,
    shouldRemoveGmailLineBreakBeforeReply: _propTypes.default.bool,
    shouldRemoveEmailSignature: _propTypes.default.bool
  }),
  maxHeight: _propTypes.default.number,
  onExceedsMaxHeight: _propTypes.default.func,
  textSeleniumKey: _propTypes.default.string,
  WrapperComponent: _propTypes.default.node
};
var defaultProps = {
  onExceedsCharLimit: function onExceedsCharLimit() {},
  WrapperComponent: 'div'
};
var SanitizedText = (0, _react.memo)(function (_ref2) {
  var body = _ref2.body,
      formattingOptions = _ref2.formattingOptions,
      maxHeight = _ref2.maxHeight,
      onExceedsMaxHeight = _ref2.onExceedsMaxHeight,
      textSeleniumKey = _ref2.textSeleniumKey,
      WrapperComponent = _ref2.WrapperComponent;
  var fullHeightTextRef = (0, _react.useRef)(null);
  var formattedBody = body ? _HtmlSanitizer.default.formatHtml(body, (0, _extends2.default)({}, formattingOptions)) : '';
  var handleExceedsMaxHeight = (0, _react.useCallback)(function () {
    var onResize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (!fullHeightTextRef || !fullHeightTextRef.current) {
      return;
    }

    if (fullHeightTextRef.current.clientHeight > maxHeight) {
      onExceedsMaxHeight(true);
    } else if (onResize) {
      onExceedsMaxHeight(false);
    }
  }, [maxHeight, fullHeightTextRef, onExceedsMaxHeight]);
  (0, _react.useEffect)(function () {
    var isNumericMaxHeight = !isNaN(maxHeight);
    var allowMaxHeightTruncation = isNumericMaxHeight && formattedBody;

    if (allowMaxHeightTruncation) {
      window.addEventListener('resize', handleExceedsMaxHeight);
      return handleExceedsMaxHeight(false);
    }

    return function () {
      if (allowMaxHeightTruncation) {
        window.removeEventListener('resize', handleExceedsMaxHeight);
      }
    };
  });

  if (!formattedBody) {
    return null;
  }

  return _react.default.createElement("div", {
    ref: fullHeightTextRef
  }, _react.default.createElement(StyledText, {
    dangerouslySetInnerHTML: {
      __html: formattedBody
    },
    "data-test-id": textSeleniumKey,
    isPlainText: Boolean(formattingOptions && formattingOptions.isPlainText),
    tagName: WrapperComponent
  }));
});
SanitizedText.propTypes = propTypes;
SanitizedText.defaultProps = defaultProps;
var _default = SanitizedText;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/components/SanitizedText.js
// module id = 397
// module chunks = 209 210 211 212